import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';

import Button from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

export const HeaderArticle = styled.article`
  display: flex;
  justify-content: space-between;
  align-items: start;
`;

export const AlertButtonSection = styled.section`
  ${stacked._2x};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  padding: 16px 0;
`;

export const AlertText = styled.p`
  ${font.tiny};
  color: ${colors['$hpx-grey-600']};
`;

export const NumFilterBadge = styled.span`
  ${font.tiny};
  display: inline-block;
  height: 16px;
  width: 16px;
  background: ${colors['$hpx-teal-600']};
  color: ${colors['$hpx-white']};
  border-radius: 50%;
  padding: 1px 1px 1px 2px;
  text-align: center;
  margin-right: 8px;
`;

export const AllFiltersMenuHeaderText = styled.p`
  ${font.sm};
`;

export const NumFilteredListings = styled.span`
  font-weight: bold;
`;

export const ClearFiltersButton = styled.button`
  ${font.sm};
  color: ${colors['$hpx-red-500']};
  font-weight: normal;
  background-color: none;
  border: none;
  padding: 6px 12px;
  height: 32px;
  width: 100px;
  min-width: fit-content;
  display: flex;
  align-items: center;
`;

export const FilterLabels = styled.p`
  ${font.tiny};
  color: ${colors['$hpx-grey-600']};
  padding-top: 4px;
`;

export const ButtonContainer = styled(Button)`
  min-width: 112px;
`;
